import React, { useState, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import { Modal } from 'components/Modal'
import CashRegisterList from 'components/CashRegisterTree'
import { listCashRegisters } from 'gql/query'
import { useQuery } from 'components/graphql'
import { CardItemList } from 'components/Card'
import Button from 'components/Button'

import { ModalInner } from './styled'

const CashRegisters = props => {
	const { value, onChange, height, label, fullList } = props
	const { data, queryField } = useQuery(listCashRegisters, {
		fetchPolicy: 'cache-first'
	})
	const listMap = useMemo(() => {
		return data?.[queryField]?.reduce?.((out, { id, name }) => ({ ...out, [id]: { id, name } }), {}) || {}
	}, [data, queryField])
	const [showModal, setShowModal] = useState()
	const [t] = useTranslation()

	const listItems = value.length
		? value.map(id => listMap[id])
		: [{ name: t('statistic_section.strings.all_cash_registers') }]

	const handleSave = ids => {
		const newVal = (ids.length === data?.[queryField]?.length && !fullList) ? [] : ids
		onChange(newVal)
		setShowModal(false)
	}

	return(
		<>
			<CardItemList
				items={listItems}
				ItemComponent={({ item }) => item?.name || null}
				height={height ? height : 200}
				label={(label ? label : t('common.fields.cash_registers'))}
				onAddItem={() => setShowModal(true)}
				onRemoveItem={item => onChange(value.filter(id => id !== item.id))}
				styleInverted
			/>
			{showModal &&
				<ListModal
					{...props}
					onSave={handleSave}
					onClose={() => setShowModal(false)}
				/>
			}
		</>
	)
}

const ListModal = ({ value, onSave, onClose }) => {
	const [ids, setIds] = useState(value)
	const [t] = useTranslation()

	return (
		<Modal label={t('common.fields.cash_registers')} width={1030} unmount={onClose}>
			<ModalInner>
				<CashRegisterList
					startConcealed
					startAllActive={ids.length === 0}
					activeNodesArr={ids}
					hideNoCRBranches
					cardsInRow={2}
					onChange={setIds}
					onChangeDelay={0}
				/>
			</ModalInner>
			<Button text={t('common.buttons.apply')} onClick={e => onSave(ids)} />
		</Modal>
	)
}

CashRegisters.defaultProps = {
	value: []
}

CashRegisters.propTypes = {
	value: PropTypes.array,
	onChange: PropTypes.func.isRequired
}

export default CashRegisters
